// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/www/morellato-oms-ui/src/models/useLoading';
import model_2 from '/var/www/morellato-oms-ui/src/.umi/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'useLoading', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
